module.exports = __webpack_public_path__ + "img/financial_advice_faces@2x.b62d6401.png";